import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import KtzhBackdrop from '../../components/auth/ktzh-backdrop.component';
import { useAuth } from '../../contexts/auth.context';
import emblem from '../../assets/images/ktzh-emblem.png';
import classes from './styles.module.scss';

const LandingPage = () => {
  const navigate = useNavigate();
  const { isAuthed, loading } = useAuth();

  useEffect(() => {
    if (!loading && isAuthed) {
      navigate('/files', { replace: true });
    }
  }, [isAuthed, loading, navigate]);

  return (
    <div className={classes.public}>
      <KtzhBackdrop />
      <div className={classes.shell}>
        <header className={classes.header}>
          <Link to="/" className={classes.brand}>
            <img src={emblem} alt="ҚТЖ" className={classes.brandMark} />
            <div className={classes.brandText}>
              <span className={classes.brandTitle}>aivox</span>
              <span className={classes.brandSub}>ҚАЗАҚСТАН ТЕМІР ЖОЛЫ</span>
            </div>
          </Link>
          <nav className={classes.nav}>
            <span>Возможности</span>
            <span>Безопасность</span>
            <span>Поддержка</span>
            <Link to="/login" className={classes.primaryBtn}>Войти</Link>
          </nav>
        </header>

        <section className={classes.hero}>
          <div className={classes.heroCopy}>
            <div className={classes.badge}>
              <span className={classes.badgeDot} />
              Платформа совещаний КТЖ
            </div>
            <h1 className={classes.title}>
              Совещания
              <br />
              идут <span className={classes.accent}>по расписанию</span>
            </h1>
            <p className={classes.lead}>
              AIVOX записывает оперативки, протоколирует решения по перевозкам и логистике
              и сам ставит поручения. Точность 98%, казахский и русский — без ручных заметок.
            </p>
            <div className={classes.actions}>
              <Link to="/login" className={classes.primaryBtn}>Открыть платформу</Link>
              <Link to="/login" className={classes.secondaryBtn}>Войти</Link>
            </div>
            <div className={classes.stats}>
              <div><div className={classes.statValue}>98%</div>точность</div>
              <div><div className={classes.statValue}>40+</div>языков</div>
              <div><div className={classes.statValue}>5 ч/нед</div>экономия на протоколах</div>
            </div>
          </div>

          <div className={classes.visual} aria-hidden>
            <div className={classes.visualGlow} />
            <div className={classes.rails} />
            <svg viewBox="0 0 380 380" preserveAspectRatio="none" className={classes.trainTrack}>
              <g className={classes.railLines}>
                <line x1="158" y1="152" x2="44" y2="384" strokeWidth="4" opacity="0.32" />
                <line x1="222" y1="152" x2="336" y2="384" strokeWidth="4" opacity="0.32" />
                <line x1="158" y1="152" x2="44" y2="384" strokeWidth="3" strokeDasharray="10 16" opacity="0.9" className={classes.railDash} />
                <line x1="222" y1="152" x2="336" y2="384" strokeWidth="3" strokeDasharray="10 16" opacity="0.9" className={classes.railDash} />
              </g>
            </svg>
            <div className={classes.train} />
            <div className={`${classes.train} ${classes.trainDelay}`} />
            <div className={classes.waveBars}>
              <span className={classes.waveBar} style={{ height: '44%' }} />
              <span className={classes.waveBar} style={{ height: '64%', animationDelay: '0.2s' }} />
              <span className={`${classes.waveBar} ${classes.waveBarGold}`} style={{ height: '100%', animationDelay: '0.1s' }} />
              <span className={classes.waveBar} style={{ height: '54%', animationDelay: '0.3s' }} />
              <span className={classes.waveBar} style={{ height: '40%', animationDelay: '0.4s' }} />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default LandingPage;
